export default "__VITE_ASSET__591db097__"